module.exports = __webpack_public_path__ + "img/feature_buy_th.b7385ae7.png";